@if (landingPage.custom) {
  <div class="landing-page common__body-container">
    <header-landing [configuration]="landingPage.custom"></header-landing>
    <main  class="landing-page__body">
      <div class="landing-page__container">
        <div class="landing-page__header-container">
          <div class="landing-page__title-container">
            <div class="landing-page__title-header-container">
              <h1 class="landing-page__title-container-text">
                <span-tooltip
                  class="landing-page__title-text landing-page__desktop"
                  [text]="(landingPage.concept?.titlePrefix && skin === 'icam-red' && !landingPage.showProcedure && !landingPage.showConceptUserProfile && landingPage.showButtonNewQuery) ? landingPage.concept?.titlePrefix + ' / ' + landingPage.titleShared : landingPage.titleShared">
                </span-tooltip>
                <span class="landing-page__title-text landing-page__tablet">
                  {{(landingPage.concept?.titlePrefix && skin === 'icam-red' && !landingPage.showProcedure && !landingPage.showConceptUserProfile && landingPage.showButtonNewQuery) ? landingPage.concept?.titlePrefix + ' / ' + landingPage.titleShared : landingPage.titleShared}}
                </span>
              </h1>
              @if (landingPage.task?.taskId) {
                <div class="landing-page__date-alert-header-container landing-page__desktop">
                  <div class="common-tag__neutral-light">
                    <span class="common-tag__neutral-label-text">
                      <span afTranslate="landing-page.created-by">
                      </span>
                      <span> {{landingPage.userLogin}}</span>
                      <span> {{landingPage.creationDate | convertDate:'without-time'}} </span>
                    </span>
                  </div>
                  @if (landingPage.taskExpirated >= 1 && landingPage.task && ['Resuelta', 'Cerrada', 'Cerrada sin resolver'].indexOf(landingPage.task.state) === -1) {
                    <div role="status"
                        [attr.aria-label]="('task-edit.task-has-expired' | afTranslate) + ' ' + landingPage.taskExpirated + ' ' + landingPage.dayText">
                      <i aria-hidden="true"
                        class="lf-icon-notification common-special-icon__notification-md"
                        pTooltip="{{('task-edit.task-has-expired' | afTranslate)}} {{landingPage.taskExpirated}} {{landingPage.dayText}}"
                        tooltipPosition="top">
                        <span aria-hidden="true"
                          class="common-special-icon__dot-md-notification"></span>
                      </i>
                    </div>
                  }
                </div>
                @if (landingPage.task?.taskTypeId === 3) {
                  <button type="button" class="common-button__text-border landing-page__desktop"
                    (click)="editConcept()">
                    <span class="common-button__text-title"
                      afTranslate="landing-page.concept-access">
                    </span>
                  </button>
                  <button type="button" class="common-button__icon-xl-border landing-page__tablet"
                    [attr.aria-label]="'rename-modal.edit-concept' | afTranslate"
                    (click)="editConcept()">
                    <i aria-hidden="true" class="lf-icon-forms common-icon__lg"></i>
                  </button>
                }
              }@else if (landingPage.showButtonsHeader) {
                <div class="landing-page__buttons-header-container">
                  @if (landingPage.conceptSelected?.poll && landingPage.conceptSelected?.pollExpirationDate && !landingPage.showProcedure) {
                    <div class="common-tag__neutral-light landing-page__desktop">
                      <span class="common-tag__neutral-label-text">
                        <span afTranslate="expanded-menu.expiration-period">
                        </span>
                        <span> {{landingPage.conceptSelected?.pollExpirationDate | convertDate:'without-time'}} </span>
                      </span>
                    </div>
                  }
                  @if (landingPage.conceptSelected?.description && !landingPage.conceptSelected?.poll) {
                    <button type="button" class="common-button__icon-lg-noborder landing-page__desktop"
                      (click)="showConceptInfo()"
                      aria-label="mostrar informacion del concepto">
                      <i aria-hidden="true" class="lf-icon-information common-icon__md"></i>
                    </button>
                  }
                  @if ((!task && (!public || isMonitoring) && landingPage.conceptSelected?.conceptObjectId && !landingPage.showProcedure && !landingPage.showConceptUserProfile) || landingPage.conceptSelected?.poll) {
                    <button type="button" class="common-button__icon-lg-noborder"
                      [ngClass]="{'landing-page__desktop': !landingPage.conceptSelected?.poll}"
                      (click)="printConcept()"
                      aria-label="imprimir concepto">
                      <i aria-hidden="true" class="lf-icon-print common-icon__md"></i>
                    </button>
                  }
                  @if (landingPage.showButtonUserProfile && !landingPage.showConceptUserProfile) {
                    <button type="button" class="common-button__text-border landing-page__desktop"
                      [disabled]="landingPage.disabledButtonsHeader"
                      (click)="showUserProfile()">
                      <span class="common-button__text-title"
                        afTranslate="result-search.user-profile">
                      </span>
                    </button>
                  }
                  @if (landingPage.showButtonProcedures && !landingPage.showProcedure) {
                    <button type="button" class="common-button__text-border landing-page__desktop"
                      [disabled]="landingPage.disabledButtonsHeader"
                      (click)="showProcedures()">
                      <span class="common-button__text-title"
                        [afTranslate]=" skin === 'icam-red' ? 'landing-page.all-queries' : 'landing-page.all-procedures'">
                      </span>
                    </button>
                  }
                  @if (skin === 'icam-red' && landingPage.showButtonNewQuery) {
                    <button type="button" class="common-button__icon-xl"
                      [disabled]="landingPage.disabledButtonsHeader"
                      [pTooltip]="'landing-page.create-new-query' | afTranslate"
                      (click)="createNewQuery()"
                      aria-label="crear nueva consulta">
                      <i aria-hidden="true" class="lf-icon-add-round common-icon__lg"></i>
                    </button>
                  }
                </div>
                @if (!landingPage.conceptSelected?.poll && (landingPage.showButtonProcedures || landingPage.showButtonUserProfile || (!task && (!public || isMonitoring) && !landingPage.showProcedure) || landingPage.conceptSelected?.description)) {
                  <button-with-menu-action class="landing-page__tablet landing-page__tablet--action-menu"
                    [item]="landingPage.headerOptions"
                    (configureMenuEmitter)="openHeaderAction()"
                    (launchActionEmitter)="launchHeaderAction($event.action)">
                  </button-with-menu-action>
                }
              }
            </div>
            <div class="landing-page__second-line-title-container landing-page__tablet">
              @if (landingPage.conceptSelected?.poll && landingPage.conceptSelected?.pollExpirationDate && !landingPage.showProcedure) {
                <div class="common-tag__neutral-light">
                  <span class="common-tag__neutral-label-text">
                    <span afTranslate="expanded-menu.expiration-period">
                    </span>
                    <span> {{landingPage.conceptSelected?.pollExpirationDate | convertDate:'without-time'}} </span>
                  </span>
                </div>
              }
              @if (landingPage.task?.taskId) {
                <div class="common-tag__neutral-light">
                  <span class="common-tag__neutral-label-text">
                    <span afTranslate="landing-page.created-by">
                    </span>
                    <span> {{landingPage.userLogin}}</span>
                    <span> {{landingPage.creationDate | convertDate:'without-time'}} </span>
                  </span>
                </div>
                @if (landingPage.taskExpirated >= 1) {
                  <div class="common-tag__new"
                    role="status"
                    aria-live="polite">
                    <span class="common-tag__new-bullet" aria-hidden="true"
                      aria-hidden="true">
                    </span>
                    <span class="common-tag__new-label-text">
                      <span afTranslate="task-edit.task-has-expired">
                      </span>
                      <span>{{landingPage.taskExpirated}} {{landingPage.dayText}}</span>
                    </span>
                  </div>
                }
              }
            </div>
          </div>
          @if (!landingPage.showProcedure && landingPage.dataHeader?.customBreadcrumbs && !landingPage.concept?.poll) { 
            <nav  class="common-breadcrumb__container"
              aria-label="Ruta de navegación">
              <div class="common-breadcrumb__container-all-breadcrumbs">
                <ol class="common-breadcrumb__container-breadcrumbs">
                  <li>
                    <button type="button" class="common-breadcrumb__button-home"
                      [disabled]="true"
                      aria-label="home">
                      <i aria-hidden="true" class="lf-icon-map-marker common-icon__md"></i>
                    </button>
                  </li>
                  @for (breadcrumb of landingPage.dataHeader?.customBreadcrumbs; track $index) {
                    <li class="common-breadcrumb__container-element-breadcrumb"
                      [ngClass]="$last?'common-breadcrumb__container-element-breadcrumb--with-action':'landing-page__desktop'"
                      [id]="$index"
                      [attr.aria-current]="$last ? 'page' : null">
                      <span-tooltip class="common-breadcrumb__label-text-breadcrumb common-breadcrumb__label-text-breadcrumb--disabled landing-page__desktop"
                        [ngClass]="{'common-breadcrumb__label-text-breadcrumb--selected': $last}"
                        [text]="breadcrumb"></span-tooltip>
                      <span class="common-breadcrumb__label-text-breadcrumb common-breadcrumb__label-text-breadcrumb--disabled common-breadcrumb__label-text-breadcrumb--selected landing-page__tablet">{{breadcrumb}}</span>
                      @if (!$last) {
                        <span aria-hidden="true" class="common-breadcrumb__icon-arrow">&gt;</span>
                      }
                    </li>
                  }
                </ol>
              </div>
            </nav>
          }
        </div>
        @if (!landingPage.showProcedure) {
            @if (landingPage.task?.taskId && landingPage.showTask) {
              <task-edit-custom
                [taskSelect]="landingPage.task"
                [concept]="landingPage.conceptTask">
              </task-edit-custom>
            }@else if (landingPage.conceptSelected) {
              @if (!landingPage.showConceptUserProfile) {
                @if (!landingPage.conceptSelected.sequentialView) {
                  <concept-form-custom
                    [concept]="landingPage.conceptSelected"
                    [published]="concept.publicShared"
                    [evaluationId]="landingPage.dataHeader?.evaluationId"
                    [footerConceptPublic]="landingPage.footerConceptPublic"
                    [formalitiesList]="landingPage.concept?.list"
                    [disabledSave]="landingPage.disabledButtonsHeader"
                    [lockComToManager]="landingPage.lockComToManager"
                    (launchAction)="launchAction($event)">
                  </concept-form-custom>
                }@else{
                  <concept-form-sequential class="landing-page__container-centered"
                    [concept]="landingPage.conceptSelected"
                    [public]="public"
                    [evaluationId]="landingPage.dataHeader?.evaluationId"
                    [footerConceptPublic]="landingPage.footerConceptPublic"
                    [formalitiesList]="landingPage.concept?.list"
                    [disabledSave]="landingPage.disabledButtonsHeader"
                    (launchAction)="launchAction($event)">
                  </concept-form-sequential>
                }
              }@else if (landingPage.conceptUserProfile) {
                <concept-form-custom
                  [concept]="landingPage.conceptUserProfile"
                  [published]="concept.publicShared"
                  [evaluationId]="landingPage.dataHeader?.evaluationId"
                  [footerConceptPublic]="landingPage.footerConceptPublic"
                  [lockComToManager]="landingPage.lockComToManager"
                  (launchAction)="launchAction($event)">
                </concept-form-custom>
              }
            }
        }@else {
          <concept-list-landing
            [list]="landingPage.concept?.list"
            [showList]="landingPage.showProcedure"
            [proceduresText]="landingPage.proceduresText">
          </concept-list-landing>
          <div class="concept-form__footer">
            <div class="concept-form__footer-buttons-auto">
              <button type="button" (click)="goBack()">
                <span
                  afTranslate="common.return"
                  class="common-button__text-title">
                </span>
              </button>
            </div>
          </div>
        }
      </div>
    </main>
    <customize-footer [configureOptions]="landingPage.custom"></customize-footer>
  </div>
}
